<template>
  <div>
    <slot>Base tab control header</slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>